// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  position: relative;
}

body {
  height: 100vh;
  font-family: "Montserrat", sans-serif !important;
  -webkit-user-select: unset;
          user-select: unset;
}
body a {
  text-decoration: none;
}

.card-view.ant-card-hoverable:hover {
  box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);
}
.card-view .ant-card-body {
  padding: 0;
}
.card-view .ant-card-body a {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  color: var(--dark);
}
.card-view .ant-card-body a .text {
  margin: 0 10px;
  font-weight: 500;
}
.card-view .ant-card-body a svg {
  font-size: 22px;
}

img,
svg {
  vertical-align: baseline !important;
}

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 2;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.ck .ck-content {
  height: 400px !important;
  max-height: 400px !important;
  border: 1px solid var(--input-border) !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}
.ck .ck-content:hover {
  border: 1px solid var(--box-shadow);
}

.ck .ck-toolbar {
  border: 1px solid var(--input-border) !important;
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}
.ck .ck-toolbar:hover {
  border: 1px solid var(--box-shadow);
}

.ant-modal.large-modal {
  width: 800px !important;
}

.label-hidden label {
  visibility: hidden;
}

.ant-descriptions:not(.ant-descriptions-bordered) .ant-descriptions-item-label {
  font-weight: bold;
}

.ant-card.h-100 .ant-card-body {
  height: 100%;
}

.global-settings .ant-card.h-100 {
  background: rgba(255, 255, 255, 0.28);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  -webkit-backdrop-filter: blur(15px);
          backdrop-filter: blur(15px);
  border: none;
}
.global-settings .ant-card.h-100 .ant-result-icon .anticon svg {
  fill: rgb(35, 163, 0);
}
.global-settings .ant-card.h-100 .ant-result-title {
  color: var(--bg-color);
  font-size: 28px;
}
.global-settings .ant-card.h-100 .ant-result-subtitle {
  color: var(--bg-color);
}
.global-settings .ant-card.h-100 .ant-card-body {
  height: auto;
}

.story_img .ant-upload-list-item-actions {
  display: block;
}
.story_img .ant-upload-list-item-actions .anticon-eye svg {
  font-size: 16px;
}

.ant-upload-list-item-actions {
  display: flex;
  justify-content: center;
  align-items: center;
}
.ant-upload-list-item-actions .anticon-eye svg {
  font-size: 20px;
}

.extra-color-wrapper-contain {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.extra-img-wrapper-contain {
  width: auto;
  max-height: 25px;
  margin-top: 7px;
  border-radius: 8px;
}

.page-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: var(--anchor-wrapper-bg);
}

[data-theme=dark] .loader {
  background-color: rgba(27, 37, 49, 0.5);
}
[data-theme=dark] .page-loading {
  background-color: var(--anchor-wrapper-bg);
}
[data-theme=dark] .ant-menu-inline {
  border-right: none;
}
[data-theme=dark] .card-view .ant-card-body a {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast .Toastify__toast-theme--light {
  color: var(--light-text);
  background: var(--body-bg);
}
[data-theme=dark] .antd-toast .Toastify__close-button--light {
  color: var(--light-text);
}
[data-theme=dark] .antd-toast .Toastify__toast-body {
  height: 60px !important;
  color: var(--light-text);
  font-size: 14px;
  letter-spacing: 1px;
  font-weight: 500;
}
[data-theme=dark] .ck.ck-editor__main > .ck-editor__editable {
  background: var(--dark-background);
}
[data-theme=dark] .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  border-color: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar {
  background: var(--dark-background);
  border-color: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar * {
  color: var(--light-text) !important;
}
[data-theme=dark] .ck.ck-button:not(.ck-disabled):hover,
[data-theme=dark] a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--dark-grey);
}
[data-theme=dark] .ck.ck-toolbar .ck.ck-toolbar__separator {
  background: var(--dark-grey);
}

.cs-avatar {
  overflow: hidden !important;
}
.cs-avatar img {
  width: 40px;
  height: 40px;
  overflow: hidden !important;
}

.antdImgUpload .anticon-delete {
  display: none !important;
}

.antdImgUpload .anticon-eye {
  margin-left: 35px !important;
}

.map-button {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  right: 10px;
  bottom: 190px;
  border: none;
  width: 40px;
  height: 40px;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
}

.google-map-button {
  cursor: pointer;
  position: absolute;
  z-index: 99;
  right: 10px;
  bottom: 120px;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  font-size: 20px;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  color: #000000;
}

.map-container {
  position: relative;
}

.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,
.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {
  margin: 10px 0 !important;
}

.alert {
  padding: 15px 16px;
  background: #cfe2ff;
  margin-bottom: 20px;
  border-radius: 8px;
  color: #000000;
}

.alert-header {
  display: flex;
  align-items: center;
}
.alert-header p {
  color: #000000;
  font-weight: 600;
  font-size: 18px;
  padding: 0;
  margin: 0;
}

.alert-icon {
  font-size: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.ant-form-item-control-input-content .ant-input-suffix .anticon-eye-invisible svg {
  fill: var(--bg-color);
}
.ant-form-item-control-input-content .ant-input-suffix .anticon-eye svg {
  fill: var(--bg-color);
}
.ant-form-item-control-input-content .ant-input-suffix .ant-form-item-feedback-icon {
  margin-left: 10px;
}

[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .anticon-eye-invisible svg {
  fill: #b4bed2;
}
[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .anticon-eye svg {
  fill: #b4bed2;
}
[data-theme=dark] .ant-form-item-control-input-content .ant-input-suffix .ant-form-item-feedback-icon {
  margin-left: 10px;
}

.order {
  position: relative;
}
.order .ant-image-mask {
  border-radius: 8px;
}
.order .ant-image-mask:hover {
  border-radius: 8px;
}
.order .show-bonus {
  position: absolute;
  right: 12px;
  top: 0px;
  background: #283142;
  color: white;
  border-radius: 8px;
  padding: 3px 12px;
}

.report-products .ant-card-body {
  border: 1px solid transparent;
  transition: all ease-in-out 300ms;
  border-radius: 10px;
  cursor: pointer;
}
.report-products .ant-card-body:hover {
  border: 1px solid #3e79f7;
}
.report-products .active .ant-card-body {
  border: 1px solid rgba(62, 121, 247, 0.6);
  background: rgba(62, 121, 247, 0.1);
}

.borderRadius {
  border-radius: 8px;
}

.extras .ant-image-mask {
  border-radius: 8px;
}

.settings-button .icon {
  font-size: 18px;
  animation: animate 5s ease-in-out infinite;
  justify-content: space-between;
}

.text-hover {
  transition: all 0.3s ease-in-out;
}
.text-hover:hover {
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  color: #3e79f7;
}

.textEditor .ck .ck-content {
  min-height: 300px !important;
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}

.textEditor .ck .ck-toolbar {
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: #dedede !important;
}

[data-theme=dark] .ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: rgba(92, 92, 92, 0.9) !important;
}

.allDeleteButton {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px !important;
}

.ant-upload .ant-upload {
  padding: 2px;
}
.ant-upload .ant-upload img {
  overflow: hidden;
  border-radius: 8px !important;
}

.address {
  border: 1px solid #4d5b75;
  border-radius: 12px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 11px;
  cursor: pointer;
  overflow: hidden;
  overflow: hidden;
  white-space: nowrap;
}

.ant-form-item-control-input-content .rmdp-container {
  width: 100% !important;
}

.order-details {
  background: white !important;
}

[data-theme=dark] .order-details {
  background: #455560 !important;
}

.order_detail .map_show {
  border-color: #3093fa !important;
  padding: 5px 12px;
  color: #3093fa !important;
  font-size: 14px;
  cursor: pointer;
}

.order-card-title {
  font-size: 16px;
  color: #1a3353;
}

[data-theme=dark] .order-card-title {
  font-size: 16px;
  color: #d6d7dc;
}

.datepicker {
  background: transparent;
  width: 100%;
}

.datepicker .rdp-caption_label {
  font-size: 24px;
  line-height: 33px;
  font-weight: 500;
  text-transform: capitalize;
}

.datepicker .rdp-head_cell {
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  text-transform: none;
}

.datepicker .rdp-table {
  border-collapse: separate;
  border-spacing: 10px;
}

.datepicker .rdp-tbody {
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
}

.datepicker .rdp-cell {
  width: 45px;
  height: 45px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
}

[data-theme=dark] .datepicker .rdp-cell {
  width: 45px;
  height: 45px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
  border-radius: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
}

.datepicker .rdp-day {
  width: 45px;
  max-width: 45px;
  height: 45px;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.062745098);
}

.datepicker .rdp-day_selected:focus:not([aria-disabled=true]) {
  border: 1px solid #000;
}

.datepicker .rdp-button:focus,
.rdp-button:active {
  border: 1px solid transparent;
}

.rdp-months .rdp-table .rdp-cell .rdp-day_selected {
  color: white !important;
  background: #3e79f7 !important;
}

.rdp-months .rdp-table .rdp-cell .rdp-button_reset:hover {
  color: white !important;
  background: #3e79f7 !important;
}

.rdp-months .rdp-table .rdp-cell .rdp-day_today {
  color: rgb(0, 0, 0) !important;
}

[data-theme=dark] .rdp-months .rdp-table .rdp-cell .rdp-day_today {
  color: rgb(255, 255, 255) !important;
}

@media (max-width: 576px) {
  .datepicker .rdp-caption_label {
    font-size: 22px;
    line-height: 26px;
  }
  .datepicker .rdp-nav {
    width: 30%;
  }
  .datepicker .rdp-head_cell {
    font-size: 14px;
    line-height: 19px;
  }
  .datepicker .rdp-table {
    border-spacing: 6px;
  }
  .datepicker .rdp-tbody {
    border-radius: 8px;
  }
  .datepicker .rdp-cell {
    width: 30px;
    height: 30px;
    border-radius: 8px;
  }
  .datepicker .rdp-day {
    width: 28px;
    max-width: 28px;
    font-size: 14px;
    height: 30px;
    border-radius: 8px;
  }
}
.statistic-card {
  border: 1px solid #e6ebf1;
  font-size: 23px !important;
}
.statistic-card .statistic-box {
  gap: 12px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

[data-theme=dark] .statistic-card {
  border: 1px solid #4d5b75;
}

.modal_collapse {
  background: transparent !important;
}
.modal_collapse .order_card {
  border: 1px solid #e6ebf1;
}

[data-theme=dark] .modal_collapse .order_card {
  border: 1px solid #4d5b75;
}

.addon-menu .ant-card {
  border: 1px solid var(--border-color);
}

[data-theme=dark] .addon-menu .ant-card {
  border: 1px solid var(--border-color-bg-dark) !important;
}

.pac-container {
  display: none;
}

.minus-button,
.plus-button {
  background: none !important;
  border: none !important;
  color: #1a3353 !important;
}
.minus-button:hover,
.plus-button:hover {
  background: none !important;
  border: none !important;
}

[data-theme=dark] .minus-button,
[data-theme=dark] .plus-button {
  background: none !important;
  border: none !important;
  color: #b4bed2 !important;
}
[data-theme=dark] .minus-button:hover,
[data-theme=dark] .plus-button:hover {
  background: none !important;
  border: none !important;
}

.order-card {
  transition: all ease 300ms;
}
.order-card:hover {
  opacity: 0.8;
}
.order-card:hover .ant-card-actions {
  display: block;
}
.order-card .ant-card-actions {
  display: none;
}
.order-card .ant-card-meta-title {
  margin-bottom: 0 !important;
}
.order-card .ant-list-items .ant-list-item {
  padding: 4px 0 !important;
  border-bottom: none;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:first-child {
  font-size: 16px;
  font-weight: 600;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:nth-child(2) {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 170px;
  white-space: nowrap;
}
.order-card .ant-list-items .ant-list-item .ant-space-item:last-child {
  font-size: 13px;
  font-weight: 500;
}
.order-card .ant-list {
  margin-top: 16px;
}

.ant-alert.new {
  border-top: 2px solid #66c0ff !important;
}
.ant-alert.accepted {
  border-top: 2px solid #50c878 !important;
}
.ant-alert.cooking {
  border-top: 2px solid #ff7000 !important;
}
.ant-alert.delivered {
  border-top: 2px solid #4caf50 !important;
}
.ant-alert.ready {
  border-top: 2px solid #ffcc00 !important;
}
.ant-alert.canceled {
  border-top: 2px solid var(--red) !important;
}
.ant-alert.on_a_way {
  border-top: 2px solid #ffa500 !important;
}

.order-board {
  max-width: auto;
  overflow-x: scroll;
  display: flex;
  gap: 24px;
}

.dnd-column {
  min-width: 250px;
  max-width: 250px;
}
.dnd-column .h-screen {
  padding: 8px 8px 0;
  background: var(--global-bg);
  border-radius: 8px;
}
.dnd-column .ant-alert {
  background: var(--global-bg);
  border-radius: 8px !important;
  border: 0.5px solid var(--border-color);
}

[data-theme=dark] .h-screen {
  background: var(--bg-color);
}
[data-theme=dark] .ant-alert {
  background: var(--bg-color);
  border: 0.5px solid var(--ingrediend-border);
}

.order-filter {
  width: 100%;
}
.order-filter .ant-space-item {
  width: calc((100% - 48px) / 6);
}

.hiddin-input {
  background: rgba(0, 0, 0, 0.5) !important;
  -webkit-backdrop-filter: blur(20px) !important;
          backdrop-filter: blur(20px) !important;
}

.search-outlined .ant-input-suffix {
  opacity: 0;
}
.search-outlined:hover .ant-input-suffix {
  opacity: 0.5;
  cursor: pointer;
}

.search-outlined-none .ant-input-suffix {
  opacity: 0;
}

.no-style {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
}

iframe#webpack-dev-server-client-overlay {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/app.scss"],"names":[],"mappings":"AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,0BAAA;UAAA,kBAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;;AAKE;EACE,4CAAA;AAFJ;AAKE;EACE,UAAA;AAHJ;AAKI;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAHN;AAKM;EACE,cAAA;EACA,gBAAA;AAHR;AAMM;EACE,eAAA;AAJR;;AAUA;;EAEE,mCAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AAPF;;AAUA;EACE,wBAAA;EACA,4BAAA;EACA,gDAAA;EACA,0CAAA;EACA,2CAAA;AAPF;AAQE;EACE,mCAAA;AANJ;;AAUA;EACE,gDAAA;EACA,uCAAA;EACA,wCAAA;AAPF;AAQE;EACE,mCAAA;AANJ;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,kBAAA;AAPF;;AAWE;EACE,iBAAA;AARJ;;AAaE;EACE,YAAA;AAVJ;;AAeE;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,YAAA;AAZJ;AAeQ;EACE,qBAAA;AAbV;AAiBI;EACE,sBAAA;EACA,eAAA;AAfN;AAiBI;EACE,sBAAA;AAfN;AAiBI;EACE,YAAA;AAfN;;AAoBE;EACE,cAAA;AAjBJ;AAmBM;EACE,eAAA;AAjBR;;AAuBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AApBF;AAsBI;EACE,eAAA;AApBN;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,0CAAA;AArBF;;AAyBE;EACE,uCAAA;AAtBJ;AAyBE;EACE,0CAAA;AAvBJ;AA0BE;EACE,kBAAA;AAxBJ;AA6BM;EACE,wBAAA;AA3BR;AAgCE;EACE,wBAAA;AA9BJ;AA+BI;EACE,wBAAA;EACA,0BAAA;AA7BN;AAgCI;EACE,wBAAA;AA9BN;AAgCI;EACE,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AA9BN;AAkCE;EACE,kCAAA;AAhCJ;AAmCE;EACE,8BAAA;AAjCJ;AAoCE;EACE,kCAAA;EACA,8BAAA;AAlCJ;AAoCI;EACE,mCAAA;AAlCN;AAsCE;;EAEE,4BAAA;AApCJ;AAuCE;EACE,4BAAA;AArCJ;;AAyCA;EACE,2BAAA;AAtCF;AAwCE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;AAtCJ;;AA0CA;EACE,wBAAA;AAvCF;;AA0CA;EACE,4BAAA;AAvCF;;AA0CA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAvCF;;AA0CA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAvCF;;AA0CA;EACE,kBAAA;AAvCF;;AA0CA;;;;EAIE,yBAAA;AAvCF;;AAyCA;EACE,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AAtCF;;AAwCA;EACE,aAAA;EACA,mBAAA;AArCF;AAsCE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AApCJ;;AAuCA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AApCF;;AAyCM;EACE,qBAAA;AAtCR;AA0CM;EACE,qBAAA;AAxCR;AA2CI;EACE,iBAAA;AAzCN;;AAiDM;EACE,aAAA;AA9CR;AAkDM;EACE,aAAA;AAhDR;AAmDI;EACE,iBAAA;AAjDN;;AAsDA;EACE,kBAAA;AAnDF;AAqDE;EACE,kBAAA;AAnDJ;AAqDI;EACE,kBAAA;AAnDN;AAuDE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AArDJ;;AA0DE;EACE,6BAAA;EACA,iCAAA;EACA,mBAAA;EACA,eAAA;AAvDJ;AAyDI;EACE,yBAAA;AAvDN;AA4DI;EACE,yCAAA;EACA,mCAAA;AA1DN;;AA+DA;EACE,kBAAA;AA5DF;;AA8DA;EACE,kBAAA;AA3DF;;AA+DE;EACE,eAAA;EACA,0CAAA;EACA,8BAAA;AA5DJ;;AAgEA;EACE,gCAAA;AA7DF;AA8DE;EACE,gCAAA;EACA,eAAA;EACA,cAAA;AA5DJ;;AAgEA;EACE,4BAAA;EACA,0CAAA;EACA,2CAAA;AA7DF;;AA+DA;EACE,uCAAA;EACA,wCAAA;AA5DF;;AA+DA;;EAEE,8BAAA;AA5DF;;AA+DA;;EAEE,4CAAA;AA5DF;;AA+DA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AA5DF;;AAgEE;EACE,YAAA;AA7DJ;AA8DI;EACE,gBAAA;EACA,6BAAA;AA5DN;;AAiEA;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AA9DF;;AAgEA;EACE,sBAAA;AA7DF;;AAgEA;EACE,4BAAA;AA7DF;;AA+DA;EACE,8BAAA;AA5DF;;AA+DA;EACE,gCAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AA5DF;;AA8DA;EACE,eAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,cAAA;AA3DF;;AA8DA;EACE,uBAAA;EACA,WAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AA3DF;;AA8DA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AA3DF;;AA8DA;EACE,yBAAA;EACA,oBAAA;AA3DF;;AA8DA;EACE,4CAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,0CAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,YAAA;EACA,4CAAA;EACA,mBAAA;EACA,0CAAA;AA3DF;;AA8DA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,4CAAA;AA3DF;;AA8DA;EACE,sBAAA;AA3DF;;AA8DA;;EAEE,6BAAA;AA3DF;;AA8DA;EACE,uBAAA;EACA,8BAAA;AA3DF;;AA6DA;EACE,uBAAA;EACA,8BAAA;AA1DF;;AA6DA;EACE,8BAAA;AA1DF;;AA6DA;EACE,oCAAA;AA1DF;;AA6DA;EACE;IACE,eAAA;IACA,iBAAA;EA1DF;EA6DA;IACE,UAAA;EA3DF;EA8DA;IACE,eAAA;IACA,iBAAA;EA5DF;EA+DA;IACE,mBAAA;EA7DF;EAgEA;IACE,kBAAA;EA9DF;EAiEA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;EA/DF;EAkEA;IACE,WAAA;IACA,eAAA;IACA,eAAA;IACA,YAAA;IACA,kBAAA;EAhEF;AACF;AAmEA;EACE,yBAAA;EACA,0BAAA;AAjEF;AAkEE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAhEJ;;AAoEA;EACE,yBAAA;AAjEF;;AAoEA;EACE,kCAAA;AAjEF;AAkEE;EACE,yBAAA;AAhEJ;;AAqEE;EACE,yBAAA;AAlEJ;;AAuEE;EACE,qCAAA;AApEJ;;AAwEE;EACE,wDAAA;AArEJ;;AAyEA;EACE,aAAA;AAtEF;;AAyEA;;EAEE,2BAAA;EACA,uBAAA;EACA,yBAAA;AAtEF;AAuEE;;EACE,2BAAA;EACA,uBAAA;AApEJ;;AAwEA;;EAEE,2BAAA;EACA,uBAAA;EACA,yBAAA;AArEF;AAsEE;;EACE,2BAAA;EACA,uBAAA;AAnEJ;;AAuEA;EACE,0BAAA;AApEF;AAsEE;EAKE,YAAA;AAxEJ;AAoEI;EACE,cAAA;AAlEN;AAwEE;EACE,aAAA;AAtEJ;AAyEE;EACE,2BAAA;AAvEJ;AA2EI;EACE,yBAAA;EACA,mBAAA;AAzEN;AA4EQ;EACE,eAAA;EACA,gBAAA;AA1EV;AA6EQ;EACE,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AA3EV;AA8EQ;EACE,eAAA;EACA,gBAAA;AA5EV;AAkFE;EACE,gBAAA;AAhFJ;;AAqFE;EACE,wCAAA;AAlFJ;AAqFE;EACE,wCAAA;AAnFJ;AAsFE;EACE,wCAAA;AApFJ;AAuFE;EACE,wCAAA;AArFJ;AAwFE;EACE,wCAAA;AAtFJ;AAyFE;EACE,2CAAA;AAvFJ;AA0FE;EACE,wCAAA;AAxFJ;;AA4FA;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;AAzFF;;AA4FA;EACE,gBAAA;EACA,gBAAA;AAzFF;AA0FE;EACE,kBAAA;EACA,4BAAA;EACA,kBAAA;AAxFJ;AA2FE;EACE,4BAAA;EACA,6BAAA;EACA,uCAAA;AAzFJ;;AA8FE;EACE,2BAAA;AA3FJ;AA8FE;EACE,2BAAA;EACA,4CAAA;AA5FJ;;AAgGA;EACE,WAAA;AA7FF;AA+FE;EACE,8BAAA;AA7FJ;;AAiGA;EACE,yCAAA;EACA,8CAAA;UAAA,sCAAA;AA9FF;;AAkGE;EACE,UAAA;AA/FJ;AAkGI;EACE,YAAA;EACA,eAAA;AAhGN;;AAsGE;EACE,UAAA;AAnGJ;;AAuGA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AApGF;;AAuGA;EACE,wBAAA;AApGF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  position: relative;\n}\n\nbody {\n  height: 100vh;\n  font-family: 'Montserrat', sans-serif !important;\n  user-select: unset;\n\n  a {\n    text-decoration: none;\n  }\n}\n\n.card-view {\n  &.ant-card-hoverable:hover {\n    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.08);\n  }\n\n  .ant-card-body {\n    padding: 0;\n\n    a {\n      display: flex;\n      align-items: center;\n      width: 100%;\n      height: 100%;\n      padding: 24px;\n      color: var(--dark);\n\n      .text {\n        margin: 0 10px;\n        font-weight: 500;\n      }\n\n      svg {\n        font-size: 22px;\n      }\n    }\n  }\n}\n\nimg,\nsvg {\n  vertical-align: baseline !important;\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba($color: #fff, $alpha: 0.5);\n  z-index: 2;\n  user-select: none;\n  pointer-events: none;\n}\n\n.ck .ck-content {\n  height: 400px !important;\n  max-height: 400px !important;\n  border: 1px solid var(--input-border) !important;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n  &:hover {\n    border: 1px solid var(--box-shadow);\n  }\n}\n\n.ck .ck-toolbar {\n  border: 1px solid var(--input-border) !important;\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n  &:hover {\n    border: 1px solid var(--box-shadow);\n  }\n}\n\n.ant-modal.large-modal {\n  width: 800px !important;\n}\n\n.label-hidden label {\n  visibility: hidden;\n}\n\n.ant-descriptions:not(.ant-descriptions-bordered) {\n  .ant-descriptions-item-label {\n    font-weight: bold;\n  }\n}\n\n.ant-card.h-100 {\n  .ant-card-body {\n    height: 100%;\n  }\n}\n\n.global-settings {\n  .ant-card.h-100 {\n    background: rgba(255, 255, 255, 0.28);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(15px);\n    border: none;\n    .ant-result-icon {\n      .anticon {\n        svg {\n          fill: rgb(35, 163, 0);\n        }\n      }\n    }\n    .ant-result-title {\n      color: var(--bg-color);\n      font-size: 28px;\n    }\n    .ant-result-subtitle {\n      color: var(--bg-color);\n    }\n    .ant-card-body {\n      height: auto;\n    }\n  }\n}\n.story_img {\n  .ant-upload-list-item-actions {\n    display: block;\n    .anticon-eye {\n      svg {\n        font-size: 16px;\n      }\n    }\n  }\n}\n\n.ant-upload-list-item-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  .anticon-eye {\n    svg {\n      font-size: 20px;\n    }\n  }\n}\n.extra-color-wrapper-contain {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.extra-img-wrapper-contain {\n  width: auto;\n  max-height: 25px;\n  margin-top: 7px;\n  border-radius: 8px;\n}\n\n.page-loading {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--anchor-wrapper-bg);\n}\n\n[data-theme='dark'] {\n  .loader {\n    background-color: rgba($color: #1b2531, $alpha: 0.5);\n  }\n\n  .page-loading {\n    background-color: var(--anchor-wrapper-bg);\n  }\n\n  .ant-menu-inline {\n    border-right: none;\n  }\n\n  .card-view {\n    .ant-card-body {\n      a {\n        color: var(--light-text);\n      }\n    }\n  }\n\n  .antd-toast {\n    color: var(--light-text);\n    .Toastify__toast-theme--light {\n      color: var(--light-text);\n      background: var(--body-bg);\n    }\n\n    .Toastify__close-button--light {\n      color: var(--light-text);\n    }\n    .Toastify__toast-body {\n      height: 60px !important;\n      color: var(--light-text);\n      font-size: 14px;\n      letter-spacing: 1px;\n      font-weight: 500;\n    }\n  }\n\n  .ck.ck-editor__main > .ck-editor__editable {\n    background: var(--dark-background);\n  }\n\n  .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {\n    border-color: var(--dark-grey);\n  }\n\n  .ck.ck-toolbar {\n    background: var(--dark-background);\n    border-color: var(--dark-grey);\n\n    * {\n      color: var(--light-text) !important;\n    }\n  }\n\n  .ck.ck-button:not(.ck-disabled):hover,\n  a.ck.ck-button:not(.ck-disabled):hover {\n    background: var(--dark-grey);\n  }\n\n  .ck.ck-toolbar .ck.ck-toolbar__separator {\n    background: var(--dark-grey);\n  }\n}\n\n.cs-avatar {\n  overflow: hidden !important;\n\n  img {\n    width: 40px;\n    height: 40px;\n    overflow: hidden !important;\n  }\n}\n\n.antdImgUpload .anticon-delete {\n  display: none !important;\n}\n\n.antdImgUpload .anticon-eye {\n  margin-left: 35px !important;\n}\n\n.map-button {\n  cursor: pointer;\n  position: absolute;\n  z-index: 99;\n  right: 10px;\n  bottom: 190px;\n  border: none;\n  width: 40px;\n  height: 40px;\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  color: #000000;\n}\n\n.google-map-button {\n  cursor: pointer;\n  position: absolute;\n  z-index: 99;\n  right: 10px;\n  bottom: 120px;\n  border: none;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  font-size: 20px;\n  justify-content: center;\n  align-items: center;\n  background-color: #ffffff;\n  color: #000000;\n}\n\n.map-container {\n  position: relative;\n}\n\n.ant-tabs-left > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-left > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab,\n.ant-tabs-right > div > .ant-tabs-nav .ant-tabs-tab + .ant-tabs-tab {\n  margin: 10px 0 !important;\n}\n.alert {\n  padding: 15px 16px;\n  background: #cfe2ff;\n  margin-bottom: 20px;\n  border-radius: 8px;\n  color: #000000;\n}\n.alert-header {\n  display: flex;\n  align-items: center;\n  p {\n    color: #000000;\n    font-weight: 600;\n    font-size: 18px;\n    padding: 0;\n    margin: 0;\n  }\n}\n.alert-icon {\n  font-size: 30px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.ant-form-item-control-input-content {\n  .ant-input-suffix {\n    .anticon-eye-invisible {\n      svg {\n        fill: var(--bg-color);\n      }\n    }\n    .anticon-eye {\n      svg {\n        fill: var(--bg-color);\n      }\n    }\n    .ant-form-item-feedback-icon {\n      margin-left: 10px;\n    }\n  }\n}\n\n[data-theme='dark'] .ant-form-item-control-input-content {\n  .ant-input-suffix {\n    .anticon-eye-invisible {\n      svg {\n        fill: #b4bed2;\n      }\n    }\n    .anticon-eye {\n      svg {\n        fill: #b4bed2;\n      }\n    }\n    .ant-form-item-feedback-icon {\n      margin-left: 10px;\n    }\n  }\n}\n\n.order {\n  position: relative;\n\n  .ant-image-mask {\n    border-radius: 8px;\n\n    &:hover {\n      border-radius: 8px;\n    }\n  }\n\n  .show-bonus {\n    position: absolute;\n    right: 12px;\n    top: 0px;\n    background: #283142;\n    color: white;\n    border-radius: 8px;\n    padding: 3px 12px;\n  }\n}\n\n.report-products {\n  .ant-card-body {\n    border: 1px solid transparent;\n    transition: all ease-in-out 300ms;\n    border-radius: 10px;\n    cursor: pointer;\n\n    &:hover {\n      border: 1px solid #3e79f7;\n    }\n  }\n\n  .active {\n    .ant-card-body {\n      border: 1px solid rgba($color: #3e79f7, $alpha: 0.6);\n      background: rgba(62, 121, 247, 0.1);\n    }\n  }\n}\n\n.borderRadius {\n  border-radius: 8px;\n}\n.extras .ant-image-mask {\n  border-radius: 8px;\n}\n\n.settings-button {\n  .icon {\n    font-size: 18px;\n    animation: animate 5s ease-in-out infinite;\n    justify-content: space-between;\n  }\n}\n\n.text-hover {\n  transition: all 0.3s ease-in-out;\n  &:hover {\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n    color: #3e79f7;\n  }\n}\n\n.textEditor .ck .ck-content {\n  min-height: 300px !important;\n  border-bottom-left-radius: 12px !important;\n  border-bottom-right-radius: 12px !important;\n}\n.textEditor .ck .ck-toolbar {\n  border-top-left-radius: 12px !important;\n  border-top-right-radius: 12px !important;\n}\n\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background: #dedede !important;\n}\n\n[data-theme='dark'] .ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background: rgba(92, 92, 92, 0.9) !important;\n}\n\n.allDeleteButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 36px !important;\n}\n\n.ant-upload {\n  .ant-upload {\n    padding: 2px;\n    img {\n      overflow: hidden;\n      border-radius: 8px !important;\n    }\n  }\n}\n\n.address {\n  border: 1px solid #4d5b75;\n  border-radius: 12px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  padding: 0 11px;\n  cursor: pointer;\n  overflow: hidden;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.ant-form-item-control-input-content .rmdp-container {\n  width: 100% !important;\n}\n\n.order-details {\n  background: white !important;\n}\n[data-theme='dark'] .order-details {\n  background: #455560 !important;\n}\n\n.order_detail .map_show {\n  border-color: #3093fa !important;\n  padding: 5px 12px;\n  color: #3093fa !important;\n  font-size: 14px;\n  cursor: pointer;\n}\n.order-card-title {\n  font-size: 16px;\n  color: #1a3353;\n}\n\n[data-theme='dark'] .order-card-title {\n  font-size: 16px;\n  color: #d6d7dc;\n}\n\n.datepicker {\n  background: transparent;\n  width: 100%;\n}\n\n.datepicker .rdp-caption_label {\n  font-size: 24px;\n  line-height: 33px;\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.datepicker .rdp-head_cell {\n  font-size: 20px;\n  line-height: 24px;\n  font-weight: 500;\n  text-transform: none;\n}\n\n.datepicker .rdp-table {\n  border-collapse: separate;\n  border-spacing: 10px;\n}\n\n.datepicker .rdp-tbody {\n  border: 1px solid #00000010;\n  border-radius: 12px;\n}\n\n.datepicker .rdp-cell {\n  width: 45px;\n  height: 45px;\n  border: 1px solid #00000010;\n  border-radius: 12px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);\n}\n\n[data-theme='dark'] .datepicker .rdp-cell {\n  width: 45px;\n  height: 45px;\n  border: 1px solid #00000010;\n  border-radius: 12px;\n  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);\n}\n\n.datepicker .rdp-day {\n  width: 45px;\n  max-width: 45px;\n  height: 45px;\n  border-radius: 12px;\n  border: 1px solid #00000010;\n}\n\n.datepicker .rdp-day_selected:focus:not([aria-disabled='true']) {\n  border: 1px solid #000;\n}\n\n.datepicker .rdp-button:focus,\n.rdp-button:active {\n  border: 1px solid transparent;\n}\n\n.rdp-months .rdp-table .rdp-cell .rdp-day_selected {\n  color: white !important;\n  background: #3e79f7 !important;\n}\n.rdp-months .rdp-table .rdp-cell .rdp-button_reset:hover {\n  color: white !important;\n  background: #3e79f7 !important;\n}\n\n.rdp-months .rdp-table .rdp-cell .rdp-day_today {\n  color: rgb(0, 0, 0) !important;\n}\n\n[data-theme='dark'] .rdp-months .rdp-table .rdp-cell .rdp-day_today {\n  color: rgb(255, 255, 255) !important;\n}\n\n@media (max-width: 576px) {\n  .datepicker .rdp-caption_label {\n    font-size: 22px;\n    line-height: 26px;\n  }\n\n  .datepicker .rdp-nav {\n    width: 30%;\n  }\n\n  .datepicker .rdp-head_cell {\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  .datepicker .rdp-table {\n    border-spacing: 6px;\n  }\n\n  .datepicker .rdp-tbody {\n    border-radius: 8px;\n  }\n\n  .datepicker .rdp-cell {\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n  }\n\n  .datepicker .rdp-day {\n    width: 28px;\n    max-width: 28px;\n    font-size: 14px;\n    height: 30px;\n    border-radius: 8px;\n  }\n}\n\n.statistic-card {\n  border: 1px solid #e6ebf1;\n  font-size: 23px !important;\n  .statistic-box {\n    gap: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n}\n\n[data-theme='dark'] .statistic-card {\n  border: 1px solid #4d5b75;\n}\n\n.modal_collapse {\n  background: transparent !important;\n  .order_card {\n    border: 1px solid #e6ebf1;\n  }\n}\n\n[data-theme='dark'] .modal_collapse {\n  .order_card {\n    border: 1px solid #4d5b75;\n  }\n}\n\n.addon-menu {\n  .ant-card {\n    border: 1px solid var(--border-color);\n  }\n}\n[data-theme='dark'] .addon-menu {\n  .ant-card {\n    border: 1px solid var(--border-color-bg-dark) !important;\n  }\n}\n\n.pac-container {\n  display: none;\n}\n\n.minus-button,\n.plus-button {\n  background: none !important;\n  border: none !important;\n  color: #1a3353 !important;\n  &:hover {\n    background: none !important;\n    border: none !important;\n  }\n}\n\n[data-theme='dark'] .minus-button,\n[data-theme='dark'] .plus-button {\n  background: none !important;\n  border: none !important;\n  color: #b4bed2 !important;\n  &:hover {\n    background: none !important;\n    border: none !important;\n  }\n}\n\n.order-card {\n  transition: all ease 300ms;\n\n  &:hover {\n    .ant-card-actions {\n      display: block;\n    }\n\n    opacity: 0.8;\n  }\n\n  .ant-card-actions {\n    display: none;\n  }\n\n  .ant-card-meta-title {\n    margin-bottom: 0 !important;\n  }\n\n  .ant-list-items {\n    .ant-list-item {\n      padding: 4px 0 !important;\n      border-bottom: none;\n\n      .ant-space-item {\n        &:first-child {\n          font-size: 16px;\n          font-weight: 600;\n        }\n\n        &:nth-child(2) {\n          text-overflow: ellipsis;\n          overflow: hidden;\n          width: 170px;\n          white-space: nowrap;\n        }\n\n        &:last-child {\n          font-size: 13px;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n\n  .ant-list {\n    margin-top: 16px;\n  }\n}\n\n.ant-alert {\n  &.new {\n    border-top: 2px solid #66c0ff !important;\n  }\n\n  &.accepted {\n    border-top: 2px solid #50c878 !important;\n  }\n\n  &.cooking {\n    border-top: 2px solid #ff7000 !important;\n  }\n\n  &.delivered {\n    border-top: 2px solid #4caf50 !important;\n  }\n\n  &.ready {\n    border-top: 2px solid #ffcc00 !important;\n  }\n\n  &.canceled {\n    border-top: 2px solid var(--red) !important;\n  }\n\n  &.on_a_way {\n    border-top: 2px solid #ffa500 !important;\n  }\n}\n\n.order-board {\n  max-width: auto;\n  overflow-x: scroll;\n  display: flex;\n  gap: 24px;\n}\n\n.dnd-column {\n  min-width: 250px;\n  max-width: 250px;\n  .h-screen {\n    padding: 8px 8px 0;\n    background: var(--global-bg);\n    border-radius: 8px;\n  }\n\n  .ant-alert {\n    background: var(--global-bg);\n    border-radius: 8px !important;\n    border: 0.5px solid var(--border-color);\n  }\n}\n\n[data-theme='dark'] {\n  .h-screen {\n    background: var(--bg-color);\n  }\n\n  .ant-alert {\n    background: var(--bg-color);\n    border: 0.5px solid var(--ingrediend-border);\n  }\n}\n\n.order-filter {\n  width: 100%;\n\n  .ant-space-item {\n    width: calc((100% - 48px) / 6);\n  }\n}\n\n.hiddin-input {\n  background: rgba(0, 0, 0, 0.5) !important;\n  backdrop-filter: blur(20px) !important;\n}\n\n.search-outlined {\n  .ant-input-suffix {\n    opacity: 0;\n  }\n  &:hover {\n    .ant-input-suffix {\n      opacity: 0.5;\n      cursor: pointer;\n    }\n  }\n}\n\n.search-outlined-none {\n  .ant-input-suffix {\n    opacity: 0;\n  }\n}\n\n.no-style {\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: none;\n}\n\niframe#webpack-dev-server-client-overlay {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
